import TableWrapper from "../../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../../../../Components/Common/CommonHeader/CommonHeader";
import { useDispatch, useSelector } from "react-redux";
import useSelectedPspMappingColumns from "../Hooks/useSelectedPspMappingColumns";
import { useEffect } from "react";
import { getUserOrgListing } from "../UserService";
import { getOrganizationId, getOrgId } from "../../../../../Utils/CommonUtils";
import {
  setPspMappingData,
  setPspSorting,
  setUsersData,
  setUserSorting,
} from "../../../../../slices/team/users/usersSlice";
import UserFilter from "../UserFilter";
import SelectDropdownPspMapping from "./SelectDropdownPspMapping";
import { getFilteredDataWithTabs } from "../../../../../Utils/CommonService";
import PspFilter from "./PspFilter";

const PspMaping = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.users.selectedUser.detailsData);
  // const ownerId = useSelector((state) => state.common.user.information);
  const pspMappingData = useSelector(
    (state) => state.users.selectedUser.pspMappingData
  );
  const { pspMappingColumns, selectedRows, selectAll } =
    useSelectedPspMappingColumns(pspMappingData);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);

  const triggerRender = useSelector((state) => state.common.triggerRender);
  const filterForm = useSelector((state) => state.users.pspMappingFilter.form);
  const filterApi = useSelector(
    (state) => state.users.pspMappingFilter.filterApi
  );
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  // const organizationId = getOrgId();
  const enterpriseid = localStorage.getItem("enterpriseid");

  const sortColumn = useSelector((state) => state.users.pspSorting.column);
  const sortOrder = useSelector((state) => state.users.pspSorting.order);
  const ownerId = getOrganizationId();
  const userid = localStorage.getItem("userId");

  return (
    <div>
      <CommonHeader
        filterComponent={<PspFilter />}
        selectComponent={
          <SelectDropdownPspMapping selectedRows={selectedRows} />
        }
        dash={true}
      />
      <div className="drill-table-mapping">
        <TableWrapper
          columns={pspMappingColumns}
          data={pspMappingData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"PSP"}
          filterApiListEntity={"UPSM"}
          filterApiFunction={setPspMappingData}
          filterApiService={!selectAll ? getFilteredDataWithTabs : () => {}}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          enterpriseId={enterpriseid}
          userId={data.user_id}
          ownerId={ownerId}
          serverSortState={setPspSorting}
          // organizationId={organizationId}
          hideTabsWrapper={true}
        />
      </div>
    </div>
  );
};

export default PspMaping;
